import React, { Component } from 'react';
import { Button } from 'react-md';

import './ScrollButtons.scss';

class ScrollButtons extends Component {
  render() {
    return (
      <div className="scroll-container">
        <Button
          icon
          onClick={function () {
            document.getElementsByClassName(
              'SplitPane  vertical disabled',
            )[0].scrollTop -= 50;
          }}
        >
          keyboard_arrow_up
        </Button>
        <br />
        <Button
          icon
          onClick={function () {
            document.getElementsByClassName(
              'SplitPane  vertical disabled',
            )[0].scrollTop += 50;
          }}
        >
          keyboard_arrow_down
        </Button>
      </div>
    );
  }
}

export default ScrollButtons;



// WEBPACK FOOTER //
// ./src/components/ScrollButtons/ScrollButtons.jsx